export function handleOpenConsentOptions() {
  if (window && window.UC_UI) {
    window.UC_UI.showSecondLayer();
  }
}
